import React from 'react';
import PropTypes from 'prop-types';
import {notify} from "../../common/primitives/Notification/Notification";
import {_hasProperty, _isDesktop, _isMobile} from "../../common/helpers/HelperFunc";

import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import ComponentOrderPromoCode from "../ComponentOrderPromoCode/ComponentOrderPromoCode";
import ComponentSelectMainDomain from "../ComponentSelectMainDomain/ComponentSelectMainDomain";
import ComponentDomainContactData from "../ComponentDomainContactData/ComponentDomainContactData";
import ComponentPaymentWayAndInvoice from "../ComponentPaymentWayAndInvoice/ComponentPaymentWayAndInvoice";
import ComponentOrderRequiredFields from "../ComponentOrderRequiredFields/ComponentOrderRequiredFields";
import CheckBox from "../../common/primitives/CheckBox";


import RenderIf from '../../common/primitives/RenderIf/RenderIf';
import Button from '../../common/primitives/Button';
import CartLinePlan from './CartLinePlan';
import CartLineDomain from "./CartLineDomain";
import CartLineAdditionalService from "./CartLineAdditionalService";
import CartLineVPS from "./CartLineVPS";
import Price, {ConvertToEUR, FormatPrice} from '../../common/primitives/Price';

import whiteBox from '../../common/scss/WhiteBox.scss';
import buttons from '../../common/primitives/Button.scss';
import styles from './ComponentCart.scss';

import cartImg from './img/cart-small.png';
import errGrayImg from './img/err_grey.png';
import CartLineDefault from "./CartLineDefault";
import CartLineDomainTransfer from "./CartLineDomainTransfer";
import CartLineSEO from "./CartLineSEO";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import CartLineSSL from "./CartLineSSL";
import CartLineVPSAdditionalService from "./CartLineVPSAdditionalService";
import CartLineDomOther from "./CartLineDomOther";
import NoCompanySelectedPopup from "./NoCompanySelectedPopup";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import CartLineCmailPro from "./CartLineCmailPro";
import CartLineWPSupport from "./CartLineWPSupport";
import {__t} from '../../common/lang/text-resource';
import CartLineGDPRProtect from "./CartLineGDPRProtect";

class ComponentCart extends BaseComponent {

	isMobile = _isMobile();
	paymentWaySelected = '';
	promoCode = '';
	isOpen = null;
	termsAgreed = null;
	showMainDomainSelect = false;
	forcedFieldsPopupVisible = false;
	serviceDomainNameError = {};
	data = {};

	domainContactData = React.createRef();
	scrollContainer = React.createRef();
	paywayAndInvoice = React.createRef();

	constructor() {
		super(...arguments, 'ComponentCart');
	}

	/**
	 * От React 16.4, 'componentWillReceiveProps' е deprecated.
	 * Вместо нея се използва 'getDerivedStateFromProps'.
	 * Тази функция се извиква винаги, когато се смени state-a или props-a.
	 * Това става както при Mounting-а на компонента, така и след зареждането на данните с AJAX при
	 * lazyLoading-a. Този метод се използва вместо componentWillReceiveProps.
	 */
	static getDerivedStateFromProps222(nextProps, prevState) {
		if (nextProps.data.componentNewURL) {
			const {componentNewURL} = nextProps.data;
			if ((componentNewURL !== '') && (componentNewURL !== undefined)) {
				window.location = componentNewURL;
				return null;
			}
		}

		if (prevState && prevdata) {
			return prevState;
		}
		if (nextProps.data.componentData) {
			return nextProps.data;
		}
		return prevState;
	}

	componentDidMount() {
		super.componentDidMount();
		this.termsAgreed = false;
		window.addEventListener('resize', () => {
			const tmpIsMobile = _isMobile();
			const tmpIsOpen = (this.isOpen && !_isDesktop()) ? false : this.isOpen;

			let forceUpdateMobile = false;
			let forceUpdateOpen = false;
			if (this.isMobile !== tmpIsMobile) {
				forceUpdateMobile = true;
				this.isMobile = tmpIsMobile;
			}

			if (this.isOpen !== tmpIsOpen) {
				forceUpdateOpen = true;
				this.isOpen = tmpIsOpen;
			}

			if (forceUpdateMobile || forceUpdateOpen) {
				if (forceUpdateOpen) {
					this.eventRaise('ToggleCart', {isOpen: this.isOpen});
				}
				this.forceUpdate();
			}


		}, false);

		if (this.isOpen) {
			const scrollContainer = document.getElementById('js-scroll-container');
			scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
		}

		const arrDomainsWithWtongContactData = this.state.componentData.arrDomainsWithWtongContactData;

		if (Array.isArray(arrDomainsWithWtongContactData) && arrDomainsWithWtongContactData.length > 0) {
			this.showDomainContactData(arrDomainsWithWtongContactData[0]);
		}
	}

	eventConsume(eventName, eventData) {
		if (
			eventName === 'ServiceAddedToCart' ||
			eventName === 'PromoCodeApplied' ||
			eventName === 'PromoCodeRemoved' ||
			eventName === 'MainDomainChanged' ||
			eventName === 'WhoisDataChanged' ||
			eventName === 'CompanyDataApplied' ||
			eventName === 'CompanyDataRemoved' ||
			eventName === 'ContactDataChanged' ||
			eventName === 'OSAddedToCart'
		) {
			let toggleCart = false;
			if (eventName === 'ServiceAddedToCart') {
				if (!this.isOpen && _isDesktop()) {
					this.toggleCart();
				}
				if (eventData && eventData.reloadCart === false) {
					return;
				}
			}
			if (eventName === 'MainDomainChanged') {
				this.showMainDomainSelect = false;
			}
			this.reload({asPage: this.props.showAsPage}, (data) => {
				const {countServices} = data.componentData;
				if (countServices === 0 && this.isOpen) {
					toggleCart = true;
				}
				if (toggleCart) {
					this.toggleCart();
				}

				if (this.isOpen && !this.props.showAsPage) {
					const scrollContainer = document.getElementById('js-scroll-container');
					scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
				}

			});
		}
		if (eventName === 'PromoCodeApplied') {
			this.promoCode = eventData.promoCode;
			this.forceUpdate();
		}
		if (eventName === 'PromoCodeRemoved') {
			this.promoCode = '';
			this.forceUpdate();
		}
		if (eventName === 'ToggleCartDisabledState') {
			const continueButton1 = document.querySelector('#cartContinueButton1');
			const continueButton2 = document.querySelector('#cartContinueButton2');

			if (continueButton1) {
				if (eventData.disable) {
					continueButton1.setAttribute('disabled', 'disabled');
				} else {
					continueButton1.removeAttribute('disabled');
				}

			}
			if (continueButton2) {
				if (eventData.disable) {
					continueButton2.setAttribute('disabled', 'disabled');
				} else {
					continueButton2.removeAttribute('disabled');
				}
			}
		}
	}

	showDomainContactData = (cartLineId) => {
		let c = this.domainContactData.current;
		if (c) {
			c.componentVisible = true;
			c.isCompany = null;
			c.reload({cartLine: cartLineId});
			this.eventRaise('DomainContactDataPopupToggled', {visible: true});
		}
	};

	checkNoCompanySelected = () => {
		if (!this.props.showAsPage) {
			this.context.obj('NoCompanySelectedPopup')[0].showPopup(this.orderSubmit);
		} else {
			this.orderSubmit();
		}
	};

	continue = (event) => {
		HelperGoogleAnalytics4.TrackContinueButton('variant_incart');

		if (this.props.continueAction) {
			this.props.continueAction(event, 'fromCart');
			return;
		}

		window.location = '/web-hosting-order-client-data.php';
	}

	orderSubmit = () => {

		let {lines} = this.data;
		let hasError = false;

		if (hasError) {
			this.forceUpdate();
			window.scrollTo(0, 0);
			return;
		}


		const arrDomainsWithWtongContactData = this.state.componentData.arrDomainsWithWtongContactData;

		if (Array.isArray(arrDomainsWithWtongContactData) && arrDomainsWithWtongContactData.length > 0) {
			this.showDomainContactData(arrDomainsWithWtongContactData[0]);
			return;
		}

		if (this.state.componentData.forceCustomerAddress) {
			this.showForcedFieldsPopup(true);
			return;
		}

		const {needTermsCheck, is100PercentPromo} = this.data;
		if (this.termsAgreed !== true && needTermsCheck === true) {
			this.eventRaise('ShowPopup', {popupName: 'term_not_checked'});
			return;
		}

		let actionData = {};
		if (is100PercentPromo !== true) {


			const paywayAndInvoice = this.paywayAndInvoice.current;

			if (paywayAndInvoice.getComponentState().paymentWay === '') {
				this.eventRaise('ShowPopup', {popupName: 'payment_way_not_selected'});
				return;
			}

			// Валидира компонента за данните за частно лице.
			if (!paywayAndInvoice.componentValidate()) {
				return;
			}
			actionData = {
				paymentWay: paywayAndInvoice.getComponentState().paymentWay,
				isAutoRenewChecked: paywayAndInvoice.getComponentState().isAutoRenewChecked,
				registeredCardSelected: paywayAndInvoice.getComponentState().registeredCardSelected,
				'companyData': paywayAndInvoice.getComponentState().companyData
			};

			const ga4EventData = {
				currency: this.data.currency,
				value: this.data.ga4EndTotal,
				payment_type: this.data.paymentWays[paywayAndInvoice.getComponentState().paymentWay],
				items: this.data.ga4EventItems
			}

			if (_hasProperty(this.data, 'ga4EventItems') && this.data.ga4EventItems.length > 0) {

				let hasNewServiceDiscount = false;
				let hasReNewServiceDiscount = false;
				for (var i = 0; i < this.data.ga4EventItems.length; i++) {
					const coupon = this.data.ga4EventItems[i].coupon;
					if (coupon === 'Нова услуга' || coupon == 'Подновяване') {
						hasNewServiceDiscount = coupon === 'Нова услуга' ? true : hasNewServiceDiscount;
						hasReNewServiceDiscount = coupon === 'Подновяване' ? true : hasReNewServiceDiscount;
						ga4EventData['coupon'] = coupon;
					} else if (coupon) {
						ga4EventData['coupon'] = coupon;
					}
				}

				if (hasNewServiceDiscount && hasReNewServiceDiscount) {
					ga4EventData['coupon'] = 'Нова услуга/Подновяване';
				} else if (hasNewServiceDiscount) {
					ga4EventData['coupon'] = 'Нова услуга';

				} else if (hasReNewServiceDiscount) {
					ga4EventData['coupon'] = 'Подновяване';
				}
			}


			HelperGoogleAnalytics4.TrackEcommerceEvent('ga4_add_payment_info', ga4EventData);
		}

		localStorage.removeItem('PromoCodeData');
		sessionStorage.setItem('wp_installation_suggested', JSON.stringify(false));
		this.rootPage().ajaxCall('ActionOrderSubmit', actionData)
	};

	toggleMainDomainSelect = () => {
		this.showMainDomainSelect = !this.showMainDomainSelect;
		this.forceUpdate();
		this.eventRaise('MainDomainSelectPopupToggled', {visible: this.showMainDomainSelect});
	};


	toggleTermsCheck = () => {
		this.termsAgreed = !this.termsAgreed;
		this.forceUpdate();
	};

	showForcedFieldsPopup = (show) => {
		this.forcedFieldsPopupVisible = show;
		this.forceUpdate();
	}


	toggleCart = () => {
		this.isOpen = !this.isOpen;
		if (this.isOpen) {
			HelperGoogleAnalytics4.TrackViewCart(this.data.ga4EndTotal, this.data.currency, this.data.ga4EventItems);

		}

		this.eventRaise('ToggleCart', {isOpen: this.isOpen});
	};

	setDomainName = (lineId, domainName) => {
		if (domainName === '') {
			notify.error(this.messages.SSL_DOMAIN_NAME_EMPTY_ERROR);
			this.serviceDomainNameError[lineId] = true;
			this.forceUpdate();
			return;
		}
		const actionData = {
			domainName: domainName,
			cartLineId: lineId,
			asPage: this.props.showAsPage
		};


		const ajaxParam = new AjaxParam();
		ajaxParam.isLoading = false;
		ajaxParam.callbackSuccess = (data) => {
			this.serviceDomainNameError[lineId] = false;
			this.rootPage().forceUpdate();
			if (data.componentData.contextCart) {
				this.context.set('ComponentCart', data.componentData);
			}
			notify.success(this.messages.SERVICE_UPDATED_IN_CART_SUCCESS);
		};
		this.ajaxCall('ActionSetServiceDomainName', actionData, ajaxParam);
	};

	removeService = (lineId, serviceId, serviceName) => {
		const actionData = {
			lineId: lineId,
			asPage: this.props.showAsPage
		};

		let {lines} = this.data;
		let linesTMP = [];
		let line01 = null;
		lines.map((lineTMP) => {
			if (lineTMP.id == lineId) {
				lineTMP.loading = true;
				line01 = lineTMP;
			}
			linesTMP.push(lineTMP);
		});
		this.data.lines = linesTMP;
		this.forceUpdate();

		const ajaxParam = new AjaxParam();
		ajaxParam.isLoading = false;
		ajaxParam.callbackError = (data) => {
			if (line01) {
				line01.loading = false;
				notify.error(this.messages[data.componentErrors[0]] || data.componentErrors[0]);
				this.rootPage().forceUpdate();
			}
		}
		ajaxParam.callbackSuccess = (data) => {

			if (data.componentNewURL) {
				this.navigate(data.componentNewURL);
				return;
			}
			this.rootPage().forceUpdate();
			this.eventRaise('ServiceRemovedFromCart', {serviceId, serviceName});
			if (data.componentData.contextCart) {
				this.eventRaise('ContextCartUpdate', data.componentData.contextCart.componentData);
			}
			notify.success(this.messages.SERVICE_UPDATED_IN_CART_SUCCESS);
		};
		this.rootPage().ajaxCall('ActionRemoveFromCart', actionData, ajaxParam);
	};

	changeServiceTerm = (selectedOption, line) => {
		const actionData = {
			servicePriceId: selectedOption.priceId,
			cartLineId: line.id,
			asPage: this.props.showAsPage
		};

		let {lines, taxonomies} = this.data;
		const {serviceId, isNewService, id} = line;

		let linesTMP = [];
		lines.map((lineTMP) => {
			if (lineTMP.id == id) {
				lineTMP.loading = true;
			}
			linesTMP.push(lineTMP);
		});
		this.data.lines = linesTMP;
		this.forceUpdate();


		HelperGoogleAnalytics.TrackServicePriceSelectorClose(taxonomies[serviceId], isNewService, selectedOption.termEn);
		HelperGoogleAnalytics4.TrackServicePriceSelectorClose(taxonomies[serviceId], isNewService, selectedOption.termEn);

		let ajaxParam = new AjaxParam();
		ajaxParam.isLoading = false;
		ajaxParam.callbackSuccess = (data) => {
			this.rootPage().reload({}, () => notify.success(this.messages.SERVICE_UPDATED_IN_CART_SUCCESS))

		};
		this.rootPage().ajaxCall('ActionChangeCartLineTerm', actionData, ajaxParam);
	};

	getChildServicesForLine = (lineId) => {
		const {arrChildData} = this.data;
		let childrenFormatted = null;
		if (Object.keys(arrChildData).length > 0) {
			childrenFormatted = (arrChildData[lineId]) ? arrChildData[lineId] : null;
		}
		return childrenFormatted;
	};

	getCartRowComponent = (line) => {
		const {serviceType, countDomains} = line;
		let additionalInfo = '';
		switch (serviceType) {
			case 'Domains':
				return <CartLineDomain
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					removeService={this.removeService}
					showDomainContactData={this.showDomainContactData}
					childServices={this.getChildServicesForLine(line.id)}
				/>;
			case 'DomTransfer':
				return <CartLineDomainTransfer
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					removeService={this.removeService}/>;
			case 'Plan':
			case 'PlanWPAI':
			case 'ManagedVPS':
				return <CartLinePlan
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					toggleMainDomainSelect={this.toggleMainDomainSelect}
					hasMultipleDomains={countDomains > 1}
					childServices={this.getChildServicesForLine(line.id)}/>;
			case 'SiteBuilder':
			case 'SiteBuilderICN':
			case 'PlanShop':
			case 'CloudVPS':
			case 'VPS':
			case 'vPlatformVPS':
			case 'DEDICATED_SERVER':
			case 'Reseller':
			case 'PlanMail':
				return <CartLineVPS
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					childServices={this.getChildServicesForLine(line.id)}/>;
			case 'SSL_CERT':
				return <CartLineSSL
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					childServices={this.getChildServicesForLine(line.id)}
					setSSLDomainName={this.setDomainName}/>;
			case 'GDPRProtect':
				return <CartLineGDPRProtect
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					childServices={this.getChildServicesForLine(line.id)}
					serviceDomainNameError={this.serviceDomainNameError[line.id]}
					setDomainName={this.setDomainName}/>;
			case 'WPSupport':
				return <CartLineWPSupport
					data={line}
					taxonomy={this.data.taxonomies[line.serviceId]}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}
					changeServiceTerm={(selectedOption) => this.changeServiceTerm(selectedOption, line)}
					childServices={this.getChildServicesForLine(line.id)}
					setWPSupportDomainName={this.setDomainName}/>;
			case '10years_gift':
			case 'USB':
				return <CartLineAdditionalService
					data={line}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}/>;
			case 'cpanel':
			case 'WEBUZO':
			case 'Software':
				additionalInfo = `${line.serviceName}`;
				return <CartLineAdditionalService
					data={line}
					showAsPage={this.props.showAsPage}
					additionalInfo={additionalInfo}
					removeService={this.removeService}/>;
			case 'IPADDRESS':
				if (line.isRenewService) {
					return <CartLineVPSAdditionalService
						data={line}
						showAsPage={this.props.showAsPage}
						removeService={this.removeService}/>;
				}
				additionalInfo = __t(`Самостоятелен IP адрес`);
				return <CartLineAdditionalService
					data={line}
					showAsPage={this.props.showAsPage}
					additionalInfo={additionalInfo}
					removeService={this.removeService}/>;
			case 'AdWords':
				additionalInfo = __t(`Промоционален код`);
				return <CartLineAdditionalService
					data={line}
					showAsPage={this.props.showAsPage}
					additionalInfo={additionalInfo}
					removeService={this.removeService}/>;
			case 'SEO':
				return <CartLineSEO
					data={line}
					showAsPage={this.props.showAsPage}
					removeService={this.removeService}/>;
			case 'BACKUP_SPACE':
			case 'Bandwidth':
			case 'disk_space':
			case 'RAM_VPS':
				return <CartLineVPSAdditionalService
					removeService={this.removeService}
					showAsPage={this.props.showAsPage}
					data={line}/>;
			case 'DomOther':
				return <CartLineDomOther
					removeService={this.removeService}
					showAsPage={this.props.showAsPage}
					data={line}/>;
			case 'CmailPro':
				return <CartLineCmailPro
					removeService={this.removeService}
					showAsPage={this.props.showAsPage}
					childServices={this.getChildServicesForLine(line.id)}
					data={line}/>;
			default:
				return <CartLineDefault
					removeService={this.removeService}
					showAsPage={this.props.showAsPage}
					childServices={this.getChildServicesForLine(line.id)}
					data={line}/>
		}
	};
	getPriceListDiscountMessage = () => {
		const {
			hasPriceListDiscount,
			hasPromoDiscount,
			hasTermDiscount,
		} = this.data;
		if (hasPriceListDiscount !== true) {
			return null;
		}
		if (hasPromoDiscount !== true && hasTermDiscount !== true) {
			return null;
		}
		return (
			<div className={styles.warningContainer}>
				{this.props.showAsPage !== true && <hr/>}
				<table>
					<tbody>
					<tr>
						<td className={styles.vtTop} data-layout='padding-left--smm'>
							*
						</td>
						<td>
							<p>
								{__t('партньорската-отстъпка-се-изчислява-върху-сумата-8ec935')}
							</p>

						</td>
					</tr>
					</tbody>
				</table>
			</div>
		)
	};
	getVatMessage = () => {
		const {
			showMSGVat,
			noVAT,
			countryId,
			hasCompany
		} = this.data;
		if (showMSGVat) {
			return (
				<div className={styles.warningContainer}>
					{this.props.showAsPage !== true && <hr/>}
					<table>
						<tbody>
						<tr>
							<td>
								<img src={errGrayImg} alt={__t("Внимание")}/>
							</td>
							<td>
								{
									hasCompany ?
										countryId !== 'BG' ?
											<p>
												{__t('предоставените-фирмени-данни-изискват-специално-о96dc30')}
											</p>
											: <p>
												{__t('според-въведените-фирмени-данни-валутата-в-поръчк773c19')}
											</p>
										:
										<p>
											{__t('предоставените-контактни-данни-изискват-специално328e6f')}
										</p>
								}
								{
									noVAT ?
										<p>
											{__t('стойността-на-ддс-е-извадена-от-крайната-цена-на-839392')}
										</p> : null
								}
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			)
		}

		return null;
	};

	getBGDomainMessage = () => {
		const {
			hasBGDomainTransfer
		} = this.data;
		if (hasBGDomainTransfer) {
			return (
				<div className={styles.warningContainer}>
					{this.props.showAsPage !== true && <hr/>}
					<table>
						<tbody>
						<tr>
							<td>
								<img src={errGrayImg} alt="Внимание"/>
							</td>
							<td>
								<p>
									{__t('регистрацията-и-трансферът-на-домейните-на-кирили024446')}
								</p>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			)
		}

		return null;
	};

	render() {


		this.data = this.context.get('ComponentCart');


		if (this.data && this.isOpen === null) {
			this.isOpen = this.data.componentData.isOpen && _isDesktop();
			this.termsAgreed = !this.data.componentData.needTermsCheck;
		}

		const emptyState =
			<div
				className={`${styles.isEmpty} ${styles.closedState}`}
				data-layout="text-center"
				data-test={"cart-empty-state"}>
				{
					!this.loading && <div>
						<img src={cartImg} alt={__t("Количка")}/>
						{__t('Вашата количка е празна')}
					</div>
				}
			</div>;

		if (!this.data) {
			return (
				<div className={styles.mainContainer}>
					<div className={styles.container}>
						{emptyState}
					</div>
				</div>
			)
		}
		const {
			countServices,
			total,
			endTotal,
			discount,
			noVAT,
			deductedVatAmount,
			currency,
			lines,
			is100PercentPromo,
			showContinueButton,
			// promoCodeData,
			// paymentWayData,
			showLoggedInComponents,
			// selectDomainData,
			// domainContactData,
			needTermsCheck,
			forceCustomerAddress,
			onlyNewServices
		} = this.context.get(this.componentName).componentData;

		if (countServices == 0) {
			this.isOpen = false;
		}

		let promoCodeData = this.context.get('ComponentOrderPromoCode');
		let selectDomainData = this.context.get('ComponentSelectMainDomain');
		let domainContactData = this.context.get('ComponentDomainContactData');
		let paymentWayData = this.context.get('ComponentPaymentWayAndInvoice');
		let componentRequiredFields = this.context.get('ComponentOrderRequiredFields');

		this.data = this.context.get('ComponentCart').componentData;

		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		const withServices =
			<div data-layout="text-center"
				 data-test={"cart-not-empty-state"}
				 className={styles.closedState}>
				<img src={cartImg} alt={__t("Количка")}/>
				<span>
					<Button
						onClick={this.toggleCart}
						name={'showCart'}
						value={__t('Количка')}
						className={`${buttons.buttonLink} ${buttons.action}`}/>:&nbsp;
					{countServices} {countServices === 1 ? __t('услуга') : __t('услуги')}, &nbsp;
					{__t(':price с ДДС', {price: FormatPrice(Number.parseFloat(endTotal), currency)})}
				</span>
			</div>;
		///////////////////////////////////
		///////////////////////////////////
		const inactiveState = countServices > 0 ? withServices : emptyState;
		///////////////////////////////////
		const loggedInComponents = (showLoggedInComponents && this.props.showAsPage) ? <div data-layout="text-center">

			<div data-layout="margin-top--md">
				<ComponentOrderPromoCode data={promoCodeData}/>
			</div>
			{
				is100PercentPromo !== true &&
				<div>
					{this.props.showAsPage !== true && <hr data-layout="margin-top--20 padding-top--smm"/>}
					<div className={styles.invoiceCompanyContainer}>
						<ComponentPaymentWayAndInvoice
							data={paymentWayData}
							showWithWhiteBox={this.props.showAsPage}
							disableInvoiceBlock={this.props.showAsPage}
							ref={this.paywayAndInvoice}/>

					</div>
				</div>
			}

			{this.props.showAsPage !== true &&
				<hr data-layout="margin-top--20 padding-top--smm margin-bottom--smm padding-bottom--xs"/>}

		</div> : <div/>;
		///////////////////////////////////
		///////////////////////////////////
		const activeState =
			<div data-layout={this.props.showAsPage ? 'padding-top--xs margin-top--xxs text-center' : ''}>
				<section>
					{
						this.props.showAsPage ?
							<h1
								data-layout="text-center margin-bottom--md padding-bottom--xs">{__t("Преглед на поръчка")}</h1> :
							<h1 data-layout="text-center margin-top--20 margin-bottom--20">{__t("Количка")}</h1>
					}
					{this.props.showAsPage !== true && <hr/>}
					<div className={`${this.props.showAsPage === true && whiteBox.container} ${styles.services}`}>
						{
							lines.map((line, key) => {
								return <div key={key}>
									{key > 0 && <hr/>}
									<div className={styles.service}>
										{this.getCartRowComponent(line)}
									</div>
								</div>
							})
						}

						{this.getPriceListDiscountMessage()}
						{this.getVatMessage()}
						{this.getBGDomainMessage()}

					</div>


					{this.props.showAsPage !== true && <hr/>}
				</section>


				{loggedInComponents}


				<section data-layout="text-center" className={styles.totalsContainer}>
					<h1 data-layout="margin-bottom--sm margin-top--xs padding-top--smm">{__t('Сума за плащане')}</h1>
					<div
						data-layout="row gutter-none padding-top--xs padding-left--smm padding-right--smm "
						className={styles.totals}>
						<div data-layout="col 5 text-left">
							{__t('Услуги:')}
						</div>
						<div data-layout="col 7 text-right">
							<Price currency={currency} value={total}/>
							{SHVO.showEuroPrices && <>
								&nbsp;/&nbsp;
								<Price currency={'EUR'} value={ConvertToEUR(total)}/>
							</>}
						</div>
					</div>
					{
						(discount > 0) ?
							<div
								data-layout="row gutter-none padding-left--smm padding-right--smm "
								className={styles.totals}>
								<div data-layout="col 5 text-left">
									{__t('Отстъпки:')}
								</div>
								<div data-layout="col 7 text-right">
									- <Price currency={currency} value={discount}/>
									{SHVO.showEuroPrices && <>
										&nbsp;/&nbsp;
										- <Price currency={'EUR'} value={ConvertToEUR(discount)}/>
									</>}
								</div>
							</div>
							: undefined
					}
					{
						(noVAT) ?
							<>
								<div
									data-layout="row gutter-none padding-left--smm padding-right--smm "
									className={styles.totals}>
									<div data-layout="col 5 text-left">
										{__t('ДДС:')}
									</div>
									<div data-layout="col 7 text-right">
										- <Price currency={currency} value={deductedVatAmount}/>
										{SHVO.showEuroPrices && <>
											&nbsp;/&nbsp;
											- <Price currency={'EUR'} value={ConvertToEUR(deductedVatAmount)}/>
										</>}
									</div>
								</div>
							</>
							: null
					}
					<div
						data-layout="row gutter-none margin-top--smm margin-bottom--smm padding-left--smm padding-right--smm "
						className={styles.totals}>
						<div data-layout="col 5 text-left">
							{__t('Крайна цена:')}
						</div>
						<div data-layout="col 7 text-right">
							<Price currency={currency} value={endTotal} valueClass={styles.totalSum}/>
							{SHVO.showEuroPrices && <>
								&nbsp;/&nbsp;
								<Price currency={'EUR'} value={ConvertToEUR(endTotal)}/>
							</>}
						</div>
					</div>
				</section>
				{
					showLoggedInComponents && this.props.showAsPage ?
						<section className={styles.terms} data-layout="text-center">
							{
								needTermsCheck === true &&
								<div data-layout="row gutter-none margin-top--md">
									<div data-layout={`col 1 padding-top--xs`}>
										<CheckBox
											name={'terms'}
											checked={this.termsAgreed}
											customOnchange={this.toggleTermsCheck}/>
									</div>
									<div data-layout={`col 11 padding-left--smm  padding-top--xs text-left`}>
										<label htmlFor="terms" className={styles.forTerms}>
											{__t('Съгласен съм с')}
											&nbsp;<a target="_blank"
													 href="/web-hosting-page-terms-and-agreements.php">{__t('общите условия')}</a>&nbsp;
											{__t('за ползване на услугите.')}
										</label>
									</div>
								</div>
							}

							<Button
								name={'do_continue'}
								value={is100PercentPromo ? __t('Изпрати поръчката') : __t('Плащане на поръчка')}
								onClick={this.checkNoCompanySelected}
								disabled={this.rootPage().loading}
								id='cartContinueButton1'
								testId={'jstst_wawsmbozzn'}/>
						</section>
						:
						<section className={styles.terms} data-layout="text-center">
							<Button
								name={'do_continue'}
								value={__t('Продължи с поръчката')}
								onClick={(e) => this.continue(e)}
								id='cartContinueButton2'
								testId={'jstst_wawsmbozzn'}/>
						</section>
				}
			</div>;
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////
		///////////////////////////////////


		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		if (this.props.showAsPage) {
			return (
				<div>
					<RenderIf condition={forceCustomerAddress == true && this.forcedFieldsPopupVisible == true}>
						<ComponentOrderRequiredFields
							onClose={() => this.showForcedFieldsPopup(false)}
							data={componentRequiredFields}/>
					</RenderIf>

					{
						this.showMainDomainSelect &&
						<ComponentSelectMainDomain
							data={selectDomainData}
							toggleMainDomainSelect={this.toggleMainDomainSelect}/>
					}
					{
						showLoggedInComponents &&
						<ComponentDomainContactData
							data={domainContactData}
							ref={this.domainContactData}/>
					}
					<div className={`${styles.container} ${styles.asPage}`}>

						<div
							ref={this.scrollContainer}
							className={`${styles.middleContainer} ${this.isOpen ? styles.active : ''}`}
							id="js-scroll-container">
							<div className={styles.innerContainer}>
								{activeState}
							</div>
						</div>
					</div>
				</div>

			);
		} else {

			return (
				<>
					<RenderIf condition={forceCustomerAddress == true && this.forcedFieldsPopupVisible == true}>
						<ComponentOrderRequiredFields
							onClose={() => this.showForcedFieldsPopup(false)}
							data={componentRequiredFields}/>
					</RenderIf>
					<div className={styles.mainContainer} data-test={`countServices-${countServices}`}>
						{
							this.showMainDomainSelect &&
							<ComponentSelectMainDomain
								data={selectDomainData}
								toggleMainDomainSelect={this.toggleMainDomainSelect}/>
						}
						{
							// showLoggedInComponents &&
							// <ComponentDomainContactData
							// 	data={domainContactData}
							// 	ref={this.domainContactData}/>
						}

						{
							showLoggedInComponents && <NoCompanySelectedPopup data={{}}/>
						}
						<div className={styles.container}>
							<div>

								{(this.isOpen) ?
									<div>
										<div data-layout="text-center" className={styles.closedState}>
											<img src={cartImg} alt={__t("Количка")}/>
											<Button
												onClick={this.toggleCart}
												name={'hideCart'}
												value={__t('Скриване на детайли')}
												className={`${buttons.buttonLink} ${buttons.action}`}/>
										</div>
									</div>

									:
									inactiveState
								}

								<div className={styles.openCartContainer}>
									<div
										ref={this.scrollContainer}
										className={`${styles.middleContainer} ${this.isOpen ? styles.active : ''}`}
										id="js-scroll-container">
										<div className={styles.innerContainer}>
											{activeState}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>

			);
		}


		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////
		////////////////////////////////////////////////////

	}
}

ComponentCart.propsData = {
	showAsPage: PropTypes.bool
};


// React Context binding
ComponentCart.contextType = ContextDataStore;

export default ComponentCart;